"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleFilterRuleSchema = void 0;
const zod_1 = require("zod");
const filterCriteria_1 = require("./filterCriteria");
/**
 * Zod validation schema for a SingleFilterRule
 */
exports.SingleFilterRuleSchema = zod_1.z
    .object({
    comment: zod_1.z.string().optional(),
    criteria: filterCriteria_1.FilterCriteriaSchema,
})
    .and(zod_1.z
    .object({
    action: zod_1.z.enum(['include', 'exclude']),
})
    .or(zod_1.z.object({
    action: zod_1.z.enum(['sample']),
    percent: zod_1.z.number(),
})));
//# sourceMappingURL=singleFilterRule.js.map